import React, {useEffect, useState} from 'react';
import {Accordion} from '../Accordion/LocalizedAccordion';
import {t} from 'i18next';
import {DropdownInput} from './ObjectTypePicker.style';
import {OptionProps} from '@bosch/react-frok';

export interface ObjectTypePickerProps {
    readonly dataSource: OptionProps[];
    readonly defaultValue: string;
    readonly resetState: boolean;
    readonly resetInput: boolean;
    readonly disabled: boolean;
    onChange: (objectTypeSelection: string) => void;
}

export const ObjectTypePicker: React.VFC<ObjectTypePickerProps> = (props) => {
    const [objectTypeInput, setObjectTypeInput] = useState<string>(props.defaultValue ? props.defaultValue.toLowerCase() : '');
    const [objectTypeOptions, setObjectTypeOptions] = useState<OptionProps[]>(props.dataSource);

    const setState = (selectionState: string, selectionOptions: OptionProps[], resetInput: boolean) => {
        props.onChange(selectionState);
        setObjectTypeOptions(selectionOptions);
        if (resetInput) {
            setObjectTypeInput('');
        }
    };

    useEffect(() => {
        if (props.resetState) {
            setState('', props.dataSource, true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setObjectTypeInput(eventValue);
        let selectionOptions = objectTypeOptions;
        if (props.resetInput) {
            selectionOptions = objectTypeOptions.filter(type => (type.name !== eventValue));
        }
        setState(eventValue, selectionOptions, props.resetInput);
    };

    return (
        <Accordion localizedHeadline={t('OBJECT_TYPE_PICKER_CAPTION')}>
            <DropdownInput
                id={'objectType_'.concat(objectTypeInput)}
                defaultValue={props.defaultValue ? props.defaultValue.toLowerCase() : ''}
                value={objectTypeInput}
                options={objectTypeOptions}
                disabled={props.disabled}
                onChange={handleInput}
            />
        </Accordion>
    );
};
